module.exports = __webpack_public_path__ + "aa6890eee8d3a6a68e14062c7fb416a8.ttf";